import { render } from "./TechStacks.vue?vue&type=template&id=5e99600f&scoped=true"
import script from "./TechStacks.vue?vue&type=script&lang=js"
export * from "./TechStacks.vue?vue&type=script&lang=js"

import "./TechStacks.vue?vue&type=style&index=0&id=5e99600f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e99600f"]])

export default __exports__